module.exports = __webpack_public_path__ + "img/arrow-right.1446c0f0.svg";